module.exports = __webpack_public_path__ + "static/media/Public_37.17511001.jpg";